import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';

import { StyledCaptcha } from './styles/StyledCaptcha';
import { CAPRCHA_CLIENT_KEY } from './../../config';
import { CONTROLLED_INPUT_INVALID } from '../../globals';


class Captcha extends Component {
  constructor(props) {
    super(props);

    this.handleOnChangeCaptcha = this.handleOnChangeCaptcha.bind(this);
  }

  handleOnChangeCaptcha(value) {
    const { handleChange, name } = this.props;
    handleChange(value, name);
  }

  render() {
    const { validation, } = this.props;

    return (
      <StyledCaptcha>
        <ReCAPTCHA
          ref="recaptcha"
          sitekey={CAPRCHA_CLIENT_KEY}
          onChange={this.handleOnChangeCaptcha}
        />
        {(validation === CONTROLLED_INPUT_INVALID) && (
          <span className="captcha--error-message">
            Prosím potvrďte, že nejste robot.
          </span>
        )}
      </StyledCaptcha>
    )
  }
}


Captcha.propTypes = {
  handleChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  validation: PropTypes.string.isRequired,
}


export default Captcha;



// WEBPACK FOOTER //
// ./src/common/Captcha/Captcha.js